import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Aboutus from './pages/Aboutus';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Portfolio from './pages/Portfolio';
import Career from './pages/Career';
import MobileApp from './pages/MobileApp';
import WebDev from './pages/WebDev';
import UiUx from './pages/UiUx';
import DigitalMarket from './pages/DigitalMarket';
import IOT from './pages/IOT';
import Cloud from './pages/Cloud';
import ErrorPage from './pages/404Page'; // Import the ErrorPage component

import Header from './components/Header';
import Footer from './components/Footer';
import CTA from './components/CTA';

import "@fortawesome/fontawesome-free/css/all.min.css";

function App() {
  return (
    <div className="App">
     <BrowserRouter>
       <Header /> 
       <Routes>
         <Route path="/" element={<Home />} />
         <Route path="/aboutus" element={<Aboutus />} />
         <Route path="/services" element={<Services />} />
         <Route path="/contact" element={<Contact />} />
         <Route path="/portfolio" element={<Portfolio />} />
         <Route path="/career" element={<Career />} />
         <Route path="/mobile-app-development" element={<MobileApp />} />
         <Route path="/web-development" element={<WebDev />} />
         <Route path="/ui-ux-design" element={<UiUx />} />
         <Route path="/digital-marketing" element={<DigitalMarket />} />
         <Route path="/internet-of-things" element={<IOT />} />
         <Route path="/cloud-solutions" element={<Cloud />} />
         {/* Catch-all route for 404 - this should be the last route */}
         <Route path="*" element={<ErrorPage />} />
       </Routes>
       <CTA />
       <Footer/>
     </BrowserRouter>
    </div>
  );
}

export default App;